import { render, staticRenderFns } from "./moreSettings.vue?vue&type=template&id=2f771476&scoped=true&"
import script from "./moreSettings.vue?vue&type=script&lang=js&"
export * from "./moreSettings.vue?vue&type=script&lang=js&"
import style0 from "./moreSettings.vue?vue&type=style&index=0&id=2f771476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f771476",
  null
  
)

export default component.exports